import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import {timeout} from 'rxjs/operators';
import {URL_PORTAL_SERVICOS_API} from "../util/constants";

@Injectable()
export class AnexosService {

  constructor(
    private http: HttpClient
  ) { }

  uploadAnexo(base64, idSolicitacao: number, nomeArquivo) {
    const headers = new HttpHeaders();
    headers.set('Connection', 'close');
    return this.http.post(URL_PORTAL_SERVICOS_API + '/anexo/incluirAnexo', {
      idSolicitacao, dsConteudo: base64, nomeArquivo
    }, { headers }).pipe(
      timeout(30000)
    );
  }

  deleteAnexo(idAnexo: number): Observable<any> {
    return this.http.delete(URL_PORTAL_SERVICOS_API + '/anexo/removerAnexo/' + idAnexo).pipe(
      timeout(30000)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/anexos.service.ts